export function createContentAccess(access, orgId) {
  if (orgId === 9 || orgId === `9`) {
    switch (access) {
      case `basic`:
      case `standard`:
      case `premium`:
      case `enterprise`:
        return true;
      default:
        return false;
    }
  } else {
    switch (access) {
      case `coach_club`:
      case `coach_team`:
      case `premium`:
      case `enterprise`:
        return true;
      default:
        return false;
    }
  }
}

export function folderActionsAccess(access) {
  switch (access) {
    // Folders is available to everyone since new plans
    // case 'coach_rec':
    // case 'coach_club':
    // case 'coach_team':
    // case 'premium':
    // case 'enterprise':
    //   return true;
    default:
      return true;
  }
}

export function licenceManagerAccess(access) {
  switch (access) {
    case `coach_club`:
    case `enterprise`:
      return true;
    default:
      return false;
  }
}



// WEBPACK FOOTER //
// ./library/app/utils/accessLevelCheck.js